function seeMore() {
  const hiddenText = document.querySelector('.hidden-text');
  const btn = document.querySelector(".see-more-btn");

  if (hiddenText.style.display === 'none' || hiddenText.style.display === '') {
    hiddenText.style.display = 'inline'; // Show hidden text
    btn.innerText = 'See Less'; // Change button text
  } else {
    hiddenText.style.display = 'none'; // Hide the text again
    btn.innerText = 'See More'; // Revert button text
  }
}